import { useRef, useState, useMemo } from "react";
import JoditEditor from 'jodit-react';
import "./Jodit.css";

interface JoditEditorProps {
  placeholder: any;
  value: string;
  onChange: (content: string) => void;
}

const Jodit: React.FC<JoditEditorProps> = ({ placeholder, value, onChange }) => {
  const editor = useRef(null);
  const [content, setContent] = useState(value);

  const config: any = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder || 'Start typing...',
    }),
    [placeholder]
  );

  const handleBlur = (newContent: string) => {
    setContent(newContent);
    onChange(newContent);  // Ensure that the onChange function is called
  };

  

  return (
    <div className="jodit-class">
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        onBlur={handleBlur}  // Trigger onBlur to update content and call onChange
        onChange={(newContent: any) => {}}
      />
      <link type="text/css" rel="stylesheet" href="es2015/jodit.min.css" />
      <script type="text/javascript" src="es2015/jodit.min.js"></script>
    </div>
  );
};

export default Jodit;